var render, staticRenderFns
import script from "./LexnetMixin.vue?vue&type=script&lang=ts"
export * from "./LexnetMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414275ff')) {
      api.createRecord('414275ff', component.options)
    } else {
      api.reload('414275ff', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/LexnetMixin.vue"
export default component.exports